import React from 'react';
import PropTypes from 'prop-types';
import RegisterForm from 'RegisterForm';
import RegisterFormTOSPositionEnum from 'RegisterForm/RegisterFormConstants';

const SelfServeRecipientBuilderFinishedSideBarLoggedOut = props => (
  <div
    className="recipient-builder-finished-registration-form-wrapper"
  >
    <RegisterForm
      heading=""
      hideConfirmPassword
      isPromoCodeHidden
      isShowingTermsOfService={false}
      promoCode="TEMPLATE_BUILDER"
      redirectToPage="/my-documents"
      shareRegister
      shareKey={props.shareKey}
      displayTOS={RegisterFormTOSPositionEnum.TOP}
    />
  </div>
  );

SelfServeRecipientBuilderFinishedSideBarLoggedOut.propTypes = {
  shareKey: PropTypes.string.isRequired,
};

export default SelfServeRecipientBuilderFinishedSideBarLoggedOut;



// WEBPACK FOOTER //
// ./src-react/SelfServeRecipientBuilder/RecipientFinishedSideBar/SelfServeRecipientBuilderFinishedSideBarLoggedOut.jsx